import { FC, SyntheticEvent, useState } from "react";
import { Button, Image } from "antd";

/**
 * รวม url ใบเสร็จจากทั้ง 2 แหล่ง: receipt_url (ของเดิม) + file_list (ของใหม่)
 * โดยเอา receipt_url มาก่อน แล้วต่อด้วย file_list และตัดตัวซ้ำออก
 */
export const getReceiptUrls = (
  record: { receipt_url?: string | null; file_list?: string[] | null } | null | undefined
): string[] => {
  if (!record) return [];
  const urls = [
    ...(record.receipt_url ? [record.receipt_url] : []),
    ...(record.file_list ?? []),
  ].filter(Boolean) as string[];
  return Array.from(new Set(urls));
};

const ReceiptThumb: FC<{ url: string; size: number }> = ({ url, size }) => {
  const [isError, setIsError] = useState(false);
  if (isError) {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        <Button size="small" type="link">ดูใบเสร็จ</Button>
      </a>
    );
  }
  return (
    <Image
      src={url}
      width={size}
      height={size}
      style={{ objectFit: "contain", borderRadius: 4 }}
      onError={(_e: SyntheticEvent<HTMLImageElement>) => setIsError(true)}
    />
  );
};

interface ReceiptFilesProps {
  urls: string[];
  size?: number;
}

const ReceiptFiles: FC<ReceiptFilesProps> = ({ urls, size = 48 }) => {
  if (!urls.length) return null;
  return (
    <Image.PreviewGroup>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
        {urls.map((url) => (
          <ReceiptThumb key={url} url={url} size={size} />
        ))}
      </div>
    </Image.PreviewGroup>
  );
};

export default ReceiptFiles;
